import React from 'react'
import ReactMarkdown from 'react-markdown'

import { colors, fonts, padding } from '../styles'
import styled from 'styled-components'

import SocialMedia from './social-media'

const Header = (props) => {
  const { 
    className,
    text,
    logo
   } = props;

  return (
    <header className={className}>
      {logo ? <img src={logo} alt="logo" /> : null}
      {text ? <div className="markdown"><ReactMarkdown source={text} /></div> : null}
      <SocialMedia />
    </header>
  )
}

const StyledHeader = styled(Header)`
  text-align: center;
  ${fonts.lato}
  color: ${colors.blue};
  padding: 0 ${padding};

  img {
    display: block;
    margin: ${padding} auto;
    width: 100%;
    max-width: 50rem;
  }
`

export default StyledHeader
